import {
    CompareContractsInput,
    CompareContractsOutput
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { Observable } from 'rxjs';
import { contractConfigurationClient } from 'src/api/client';
import { Paginator, getAllPages } from 'src/api/pagination/paginator';

/**
 * Get all data for the given comparison input.
 *
 * The function automates handling of pagination, so any pagination-related
 * fields in the given input will be ignored.
 * @param input The CompareContractsInput to fetch data for.
 */
export function getFullComparison(input: CompareContractsInput): Promise<CompareContractsOutput> {
    return getAllPages(new CompareContractsPaginator(input));
}

export class CompareContractsPaginator implements Paginator<CompareContractsOutput> {
    private readonly input: CompareContractsInput;
    private output: CompareContractsOutput;

    constructor(input: CompareContractsInput) {
        this.input = input;
        this.output = CompareContractsOutput.clone({
            totalSize: 0,
            deltas: []
        });
    }

    nextPage(pageNumber: number, pageSize: number): Observable<CompareContractsOutput> {
        return contractConfigurationClient.compareContracts(
            CompareContractsInput.clone({
                ...this.input,
                pageNumber: pageNumber,
                pageSize: pageSize
            })
        );
    }

    accumulate(nextPage: CompareContractsOutput): boolean {
        this.output = {
            deltas: [...this.output.deltas, ...nextPage.deltas],
            totalSize: nextPage.totalSize ?? 0
        };
        return this.output.deltas.length >= this.output.totalSize!;
    }

    downSize(newSize: number) {
        this.output = {
            ...this.output,
            deltas: this.output.deltas.slice(0, newSize)
        };
    }

    getSize(): number {
        return this.output.deltas.length;
    }

    getValue(): CompareContractsOutput {
        return this.output;
    }
}
